/**
 * Environment utility functions
 */

/**
 * Get the subfolder prefix for the application
 * @returns {string} The subfolder prefix with leading slash, or empty string
 */
export const getSubfolderPrefix = () => {
    return import.meta.env.VITE_SUBFOLDER_NAME ? `/${import.meta.env.VITE_SUBFOLDER_NAME}` : '';
};

/**
 * Get an environment variable value
 * @param {string} key The environment variable key without the VITE_ prefix
 * @param {*} defaultValue Default value if the environment variable is not set
 * @returns {string} The environment variable value or default value
 */
export const getEnvVar = (key, defaultValue = '') => {
    const fullKey = `VITE_${key}`;
    return import.meta.env[fullKey] ?? defaultValue;
};
